import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, OnDestroy } from '@angular/core';
import { Observable, Subscription } from 'rxjs';
import { OrganizationsService } from '../organizations.service';
import { ServiceBase } from '../service-base';

@Injectable({
    providedIn: 'root',
})
export class ToolsService extends ServiceBase {
    constructor(private http: HttpClient, private organizationsServices: OrganizationsService) {
        super();
    }

    checkApi(apiName: string, url: string) {
        const httpOptions = {
            headers: new HttpHeaders().set('X-OrganizationId', this.organizationsServices.getCurrentOrganization()?.id ?? ''),
        };

        return this.http.get(`${this.baseUrl}/tools/checkUrl/${apiName}?url=${url}`, httpOptions);
    }
}
